"use client";
import style from "@/styles/ElevateForm.module.scss";
import { useState } from "react";
import { useForm } from "react-hook-form";
import Image from "next/image";
import { Contact_Email } from "@/lib/constants";
import CloudflareCaptcha from "@/Components/CloudflareCaptcha";

import FloatingField from "@/Ui_Elements/FloatingField/FloatingField";
import { getValidationSchema } from "@/lib/validationSchemas.js";
import { CommonSubmitForm } from "@/lib/CommonSubmitForm";
import { yupResolver } from "@hookform/resolvers/yup";

const ElevateForm = () => {

const validationSchema = getValidationSchema(1);
  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    setValue,
    clearErrors,
    reset,
    setError, // <-- added
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
  });

  const [isValidNum, setIsValidNum] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaKey, setCaptchaKey] = useState(0);

  // Cloudflare captcha callback
  const handleVerify = (token) => {
    setCaptchaToken(token || null);

    if (token) {
      setValue("captcha", token, {
        shouldValidate: true,
        shouldDirty: true,
      });
      clearErrors("captcha");
    } else {
      setValue("captcha", null);
    }
  };

  const resetCaptcha = () => {
    setCaptchaToken(null);
    clearErrors("captcha");

    // 🔥 Force remount Turnstile
    setCaptchaKey((k) => k + 1);
  };

  // Phone input change callback (from your FloatingField / intl input)
  const onPhoneChange = (isValid, rawValue) => {
    const containsOnlyNumbers = /^\d+$/.test(rawValue);

    if (containsOnlyNumbers || !rawValue) {
      setIsValidNum(isValid);
      setPhoneNumber(rawValue);
      setValue("mobile", rawValue, { shouldValidate: true });
    }
  };

  // Final submit handler
  const onSubmit = async (data, e) => {
    const isValidForm = await trigger();
    // check captcha
    if (!captchaToken) {
      setError("captcha", { type: "manual", message: "Captcha verification failed" });
      return;
    }
    if (isValidForm && isValidNum && captchaToken) {
      const res = await CommonSubmitForm(1, data);
      if (res.success) {
        reset();
        setPhoneNumber("");
        setValue("captcha", null);
        resetCaptcha();
      }
    }
  };


  return (
    <section className={`${style["contactusformmaindiv"]}`}>
      <div className="container">
        <div className={`${style["contactformbody"]}`}>
          <div className={`${style["left"]}`}>
            <div className={`${style["lefttop"]} ${style["bgcard"]}  ${style["contentpart"]}`}>
              <h2 className={`${style["title"]}`}> Transform Your Vision into Reality – Let’s Digitize Your Future!</h2>
              <p className={`${style["description"]}`}>Take the First Step Toward Smarter Management! Please submit your details, and our experts will guide you in detail</p>
              <div className={`${style["featureslistdiv"]}`}>
                <div className={`${style["featureline"]}`}>
                  <div className={`${style["icondiv"]}`}>
                    <Image src="/images/icons/check_image.png" alt="contact" width={0} height={0} />
                  </div>
                  <p className={`${style["featurename"]}`}>Customizable Learning Modules</p>
                </div>
                <div className={`${style["featureline"]}`}>
                  <div className={`${style["icondiv"]}`}>
                    <Image src="/images/icons/check_image.png" alt="contact" width={0} height={0} />
                  </div>
                  <p className={`${style["featurename"]}`}>Real-Time Analytics</p>
                </div>
                <div className={`${style["featureline"]}`}>
                  <div className={`${style["icondiv"]}`}>
                    <Image src="/images/icons/check_image.png" alt="contact" width={0} height={0} />
                  </div>
                  <p className={`${style["featurename"]}`}>Seamless User Experience</p>
                </div>
              </div>

              <h4 className={`${style["contactlineshading"]}`}>Contact By Us</h4>
              <div className={`${style["contactlinesdiv"]}`}>
                <div className={`${style["flexitem"]}`}>
                  <div className={`${style["contactlinerow"]}`}>
                    <Image className={`${style["imagebox"]}`} src="/images/icons/contact_email_ic.svg" alt="contact" width={0} height={0} />

                    <div className={`${style["contenbox"]}`}>
                      <a className={`${style["contactlink"]}`} href={`mailto:${Contact_Email}`}>
                        {Contact_Email}
                      </a>
                    </div>
                  </div>
                  {/* <div className={`${style["contactlinerow"]}`}>
                    <Image
                      className={`${style["imagebox"]}`}
                      src="/images/icons/contact_us_phone_ic.svg"
                      alt="contact"
                      width={0}
                      height={0}
                    />
                    <div className={`${style["contenbox"]}`}>
                      <a className={`${style["contactlink"]}`} href="tel:+919726748800">
                        +919726748800
                      </a>
                    </div>
                  </div> */}
                </div>
              </div>
              <h4 className={`${style["contactlineshading2"]}`}>Sales & Marketing</h4>
              <div className={`${style["contactlinesdiv"]}`}>
                <div className={`${style["flexitem"]}`}>
                  <div className={`${style["contactlinerow"]}`}>
                    <Image className={`${style["imagebox"]}`} src="/images/icons/contact_us_phone_ic.svg" alt="contact" width={0} height={0} />
                    <div className={`${style["contenbox"]}`}>
                      <a className={`${style["contactlink"]}`} href="tel:+91-942-644-2424">
                        +91-942-644-2424
                      </a>
                    </div>
                  </div>
                  <div className={`${style["contactlinerow"]}`}>
                    <Image className={`${style["imagebox"]}`} src="/images/icons/contact_us_phone_ic.svg" alt="contact" width={0} height={0} />
                    <div className={`${style["contenbox"]}`}>
                      <a className={`${style["contactlink"]}`} href="tel:+91-972-674-8800">
                        +91-972-674-8800
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className={`${style["leftbottom"]} ${style["bgcard"]}`}>
              <p className={`${style["description"]}`}>
                We are all here to listen to any doubt, query, clarification, anything from you. Just get connected with
                us and we will get back to you as soon as possible!
              </p>
              <div className={`${style["featureslistdiv"]}`}>
                <div className={`${style["featureline"]}`}>
                  <div className={`${style["icondiv"]}`}>
                    <Image src="/images/contact_us/reducecoast.svg" alt="contact" width={0} height={0} />
                  </div>
                  <p className={`${style["featurename"]}`}>Cost-effective</p>
                </div>
                <div className={`${style["featureline"]}`}>
                  <div className={`${style["icondiv"]}`}>
                    <Image src="/images/contact_us/scalesupport.svg" alt="contact" width={0} height={0} />
                  </div>
                  <p className={`${style["featurename"]}`}>Reliable Support</p>
                </div>
              </div>
            </div> */}
          </div>
          <div className={`${style["right"]} ${style["bgcard"]}  ${style["bgcardpattrent"]} `}>
            <form id="contact-form" className={`${style["formmain"]} commonformclass contact-form commonform`} onSubmit={handleSubmit(onSubmit)} autoComplete="on">
              <div className={`${style["inputgroup"]} inputgroup ${style["w-100"]}`}>
                <FloatingField
                  id="name_elevateform"
                  type="text"
                  label="Your Name"
                  placeholder="Enter your name"
                  name="name"
                  register={register}
                  error={errors.name}
                  setValue={setValue}
                  isFloatedLabel={false}
                />
              </div>

              <div className={`${style["inputgroup"]} inputgroup ${style["w-100"]}`}>
                <FloatingField
                  id="email_elevateform"
                  type="email"
                  label="Your Email"
                  placeholder="Enter your email"
                  name="email"
                  register={register}
                  error={errors.email}
                  setValue={setValue}
                  isFloatedLabel={false}
                />
              </div>
              <div className={`${style["inputgroup"]} inputgroup ${style["w-50"]}`}>
                <FloatingField
                  id="mobile_elevateform"
                  type="intl"
                  label="Phone no."
                  placeholder="Phone no."
                  name="mobile"
                  register={register}
                  phoneNumber={phoneNumber}
                  isValidNum={isValidNum}
                  onPhoneNumberChange={onPhoneChange}
                  error={errors.mobile}
                  setValue={setValue}
                  isFloatedLabel={false}
                />
              </div>
              <div className={`${style["inputgroup"]} inputgroup ${style["w-50"]}`}>
                <FloatingField
                  id="organization_elevateform"
                  type="text"
                  label="Institute"
                  placeholder="Institute Name"
                  name="organization"
                  register={register}
                  error={errors.organization}
                  setValue={setValue}
                  isFloatedLabel={false}
                />
              </div>

              <div className={`${style["inputgroup"]} inputgroup ${style["w-100"]}`}>
                <FloatingField
                  id="message_elevateform"
                  type="text"
                  label="Message"
                  placeholder="Enter your message"
                  name="message"
                  register={register}
                  error={errors.message}
                  textarea={true}
                  setValue={setValue}
                  isFloatedLabel={false}
                />
              </div>

              {/* Add other form fields here */}
              <div className={`${style["inputgroup"]} inputgroup ${style["w-50"]}`}>
                <div className={`${style["elevate-recaptcha"]} c-recaptcha`}>
                  <CloudflareCaptcha onVerify={handleVerify} key={captchaKey} />
                  {errors.captcha && <div className={`${style["error"]} captcha-error`}>{errors.captcha.message}</div>}
                  <input
                    type="hidden"
                    {...register("captcha", {
                      required: "Captcha verification failed",
                    })}
                  />
                </div>
              </div>

              <div className={`${style["formbottompart"]}`}>
                <button className={`${style["buttonsubmit"]} commonformbtn`} type="submit">
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
export default ElevateForm;
